import axios from 'axios';
import HttpClient from './utils/HttpClient';
import APIError from '../errors/APIError';
import { IIfoodOrder } from '../interfaces/IIfoodOrder';

export interface IIntegration {
  id: number;
  companyId: number;
  description: string;
  type: number;
  key?: string;
  secret?: string;
  token?: string;
  refreshToken?: string;
  active: boolean;
  createdAt: string;
  updatedAt?: string;
  deletedAt?: string;
  inactivatedAt?: string;
}

export interface ICancelReason {
  description: string;
  cancelCodeId: string;
}

export interface IIfoodStoreStatus {
  operation: string;
  salesChannel: string;
  available: boolean;
  state: string;
  reopenable: {
    identifier: string;
    type: string;
    reopenable: boolean;
  };
  validations: Array<{
    id: string;
    code: string;
    state: string;
    message: {
      title: string;
      subtitle: string;
      description: string;
    };
  }>;
  message: {
    title: string;
    subtitle: string;
    description: string;
  };
}

class IfoodService {
  private httpClient = HttpClient;

  public async updateStatus(
    orderId: string,
    companyId: number,
    status: string,
  ): Promise<IIfoodOrder> {
    try {
      const response = await this.httpClient.put(
        `/companies/${companyId}/ifood/order/${orderId}`,
        {
          status,
        },
      );

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar atualizar o status';
      }

      throw new APIError(errorMessage);
    }
  }

  public async getOrder(
    orderId: string,
    companyId: number,
  ): Promise<IIfoodOrder> {
    try {
      const response = await this.httpClient.get(
        `/companies/${companyId}/ifood/order/${orderId}`,
      );

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar atualizar o status';
      }

      throw new APIError(errorMessage);
    }
  }

  public async getClientInfo(companyId: number): Promise<IIntegration> {
    try {
      const response = await this.httpClient.get(
        `/companies/${companyId}/ifood/info`,
      );

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar atualizar o status';
      }

      throw new APIError(errorMessage);
    }
  }

  public async getCancelReasons(
    orderId: string,
    companyId: number,
    clientId: string,
  ): Promise<ICancelReason[]> {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_IFOOD_INTEGRATOR_URL}/ifood/order/${orderId}/cancellation-reasons`,
        {
          params: {
            clientId,
            companyId,
          },
        },
      );

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar atualizar o status';
      }

      throw new APIError(errorMessage);
    }
  }

  public async cancelOrder(
    orderId: string,
    companyId: number,
    reason: string,
    code: string,
    clientId: string,
  ) {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_IFOOD_INTEGRATOR_URL}/ifood/order/${orderId}/cancel`,
        {
          reason,
          code,
          companyId,
          clientId,
        },
      );

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar atualizar o status';
      }

      throw new APIError(errorMessage);
    }
  }

  public async getStoreStatus(
    companyId: number,
    clientId: string,
  ): Promise<IIfoodStoreStatus[]> {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_IFOOD_INTEGRATOR_URL}/ifood/store-status/${clientId}`,
        {
          params: {
            companyId,
          },
        },
      );

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar atualizar o status';
      }

      throw new APIError(errorMessage);
    }
  }
}

export default new IfoodService();
